var map = {
	"./coins-0.png": 1821,
	"./coins-150.svg": 9505,
	"./coins-180.svg": 3986,
	"./coins-288.svg": 9009,
	"./coins-36.svg": 9238,
	"./coins-500.svg": 7046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2157;